import { Injectable } from '@angular/core';
import { CheckInTagsService } from '@careapp-group/ng-sdk-v2-new';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { CheckInTags } from '../actions';
import { auth } from '../auth/auth.selectors';

@Injectable()
export class CheckInTagsEffects {
  getTags$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CheckInTags.REQUEST_ALL),
      switchMap(() => this.checkInTagsApi.listCheckInTags()),
      map((items) => CheckInTags.ResponseSuccessAllAction(items)),
      catchError((error) => of(CheckInTags.ResponseFailAllAction(error)))
    )
  );

  getFrequentTags$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CheckInTags.REQUEST_FREQUENTLY_USED),
      switchMap(() => this.store.pipe(select(auth.getLoggedInUser))),
      switchMap((user) => this.checkInTagsApi.listFrequentCheckInTags()),
      map((items: any[]) => CheckInTags.ResponseSuccessFrequentlyUsed(items)),
      catchError((error) => of(CheckInTags.ResponseFailFrequentlyUsed(error)))
    )
  );

  createTag$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CheckInTags.REQUEST_CREATE),
      switchMap((action) =>
        this.checkInTagsApi.createCheckInTag({ createCheckInTagDto: action.payload })
      ),
      map((result) => CheckInTags.ResponseSuccessCreateAction(result)),
      catchError((error) => of(CheckInTags.ResponseFailCreateAction(error)))
    )
  );

  updateTag$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CheckInTags.REQUEST_SAVE),
      switchMap((action) =>
        this.checkInTagsApi.updateCheckInTag({
          id: action.payload.id,
          createCheckInTagDto: action.payload.data,
        })
      ),
      map((result) => CheckInTags.ResponseSuccessSaveAction(result)),
      catchError((error) => of(CheckInTags.ResponseFailSaveAction(error)))
    )
  );

  constructor(
    private actions$: Actions<any>,
    private store: Store<any>,
    private checkInTagsApi: CheckInTagsService
  ) {}
}
